/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Segment_Process_Entire_VideoInputs */

const en_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process the entire video`)
};

const fr_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traiter la vidéo entière`)
};

const de_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das gesamte Video verarbeiten`)
};

const it_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elabora l'intero video`)
};

const ru_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработайте всё видео.`)
};

const es_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesar todo el vídeo`)
};

const zh_cn2_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理整个视频`)
};

const ja_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画全体を処理する`)
};

const hi_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरे वीडियो को प्रोसेस करें`)
};

const pt_pt2_ad_segment_process_entire_video = /** @type {(inputs: Ad_Segment_Process_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processar o vídeo inteiro`)
};

/**
* | output |
* | --- |
* | "Process the entire video" |
*
* @param {Ad_Segment_Process_Entire_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_segment_process_entire_video = /** @type {((inputs?: Ad_Segment_Process_Entire_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Segment_Process_Entire_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_segment_process_entire_video(inputs)
	if (locale === "de") return de_ad_segment_process_entire_video(inputs)
	if (locale === "it") return it_ad_segment_process_entire_video(inputs)
	if (locale === "ru") return ru_ad_segment_process_entire_video(inputs)
	if (locale === "es") return es_ad_segment_process_entire_video(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_segment_process_entire_video(inputs)
	if (locale === "ja") return ja_ad_segment_process_entire_video(inputs)
	if (locale === "hi") return hi_ad_segment_process_entire_video(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_segment_process_entire_video(inputs)
	return en_ad_segment_process_entire_video(inputs)
});